<template>
    <div class="checkout-bidding price-data">
        <SectionRowJustified v-if="priceData.shippingCosts">
            <template #title>{{ $t('Checkout.priceData.shippingCosts') }}</template>
            <template #value>{{ priceData.shippingCosts | formatPriceFilter }}</template>
        </SectionRowJustified>

        <BiddingPriceData :list-price="priceData.totalListPrice">
            <template #bid:value>
                <component
                    :is="inputComponent"
                    :value="bidAmount"
                    class="checkout-bidding__input"
                    @input="$emit('update:bidAmount', $event)"
                />
            </template>
        </BiddingPriceData>

        <div v-if="!hideLowWarning && bidTooLow" class="checkout-bidding__low-hint">
            <icon-svg filepath="info-outlined.svg" class="checkout-bidding__low-hint-icon" />
            <translate path="CheckoutBidding.lowBidHint" class="small">
                <template #price>
                    <strong>{{ priceData.totalProductPrice | formatPriceFilter }}</strong>
                </template>
            </translate>
        </div>
    </div>
</template>

<script>
import formatPriceFilter from '@/filters/formatPrice';
import BidInput from '@/components/product/auction/BidInput.vue';
import BidInputWithButtons from '@/components/product/auction/BidInputWithButtons.vue';
import SectionRowJustified from '@/components/SectionRowJustified.vue';
import BiddingPriceData from '@/components/product/auction/BiddingPriceData.vue';

export default {
    name: 'CheckoutBidding',
    components: { BiddingPriceData, SectionRowJustified, BidInputWithButtons, BidInput },
    filters: { formatPriceFilter },
    props: {
        priceData: {
            type: Object,
            required: true
        },
        bidAmount: {
            required: true
        },
        withButtons: Boolean,
        hideLowWarning: Boolean
    },
    computed: {
        bidTooLow() {
            return this.bidAmount < this.priceData.totalProductPrice;
        },
        inputComponent() {
            if (this.withButtons) {
                return BidInputWithButtons;
            }
            return BidInput;
        }
    }
};
</script>

<style lang="scss">
.was-validated .form-control.bid-input:valid {
    padding-right: 15px !important;
}
</style>

<style scoped lang="scss">
.checkout-bidding {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 15px;

    &__input {
        width: 200px;
        margin-left: auto;
        text-align: right;
    }

    &__low-hint {
        display: flex;
        gap: 1rem;
        text-wrap: pretty;
    }

    &__low-hint-icon {
        flex: 1 0 auto;
        font-size: 1.5rem;
    }
}
</style>
